/* eslint-disable no-magic-numbers */
// @flow

import _ from "lodash";
import ko from "knockout";
import vb from "validation-builder";

import { observableDocumentType } from "observable-document-type";
import { PASSPORT_RF } from "known-rest-identity-docs";

import "ko-component-expandable-select";

import type { ComponentParams } from "./types";

class Model {
	constructor(params: ComponentParams) {
		params = _.defaultsDeep({}, params, {
			documentTypeID: observableDocumentType(PASSPORT_RF),
			documentTypes: [],
			optionsExpandTitle: "Показать все опции",
			enable: true,
			resetableParameter: null,
			label: "Удостоверение личности",
			labelSuffix: {},
			withInfoSuffix: false,
			infoSuffixText: "",
			requisitesGtmProcessing: undefined,
			onDocumentTypeSelect: _.noop,
			withIdentityCountryInput: false,
			documentCountyName: null,
			documentCountryID: null,
			documentCountryDataset: null,
			disableCountryInput: false,

			// TODO: _.defaultsDeep добавляет второй элемент массива из дефолтовых значений,
			// если в параметрах пришел массив только с одним элементом
			typeSelectWidthClasses: [],
			countryTypeaheadClasses: [],
			seriesClasses: [],
			requisitesInputWidthClasses: ["width-xs-15rem", "width-sm-11rem"]
		});

		this._params = params;

		this._enable = ko.observable(this._params.enable);

		this._disableCountryInput = this._params.disableCountryInput;

		const makeCssClassesForBinding = classes =>
			_.reduce(
				classes,
				(formedClasses, value) =>
					Object.assign(formedClasses, { [value]: true }),
				{}
			);

		this._typeSelectWidthClasses = ko.pureComputed(() =>
			makeCssClassesForBinding(this._params.typeSelectWidthClasses)
		);

		this._countryTypeaheadClasses = ko.pureComputed(() =>
			makeCssClassesForBinding(this._params.countryTypeaheadClasses)
		);

		this._seriesClasses = ko.pureComputed(() =>
			makeCssClassesForBinding(this._params.seriesClasses)
		);

		this._requisitesInputWidthClasses = ko.pureComputed(() =>
			makeCssClassesForBinding(this._params.requisitesInputWidthClasses)
		);

		this.DocumentTypeID = this._params.documentTypeID;

		// this.DocumentRequisites = this._params.documentRequisites
		// 	.extend(identityDocumentRequisitesViewExtend(this.DocumentTypeID))
		// 	.extend({notify: 'always'});

		this.documentSeries = this._params.documentSeries
			.extend({
				validation: vb.all([
					vb.if(
						() =>
							this.DocumentTypeID() === "RussianResidencePermit",
						vb.all([
							vb.required(true, "Заполните"),
							vb.custom(value => {
								return /^8[0-3]$|^90$|^(ИР|БГ)-I{1,3}$/.test(
									value
								);
							}, "Заполните, например: 80 или ИР-I")
						])
					),
					vb.if(
						() =>
							this.DocumentTypeID() === "RussianBirthCertificate",
						vb.all([
							vb.required(true, "Заполните"),
							vb.custom(value => {
								// eslint-disable-next-line max-len
								return /^(X{0,3}(IX|IV|V?I{0,3})|Х{0,3}(1Х|1У|У?1{0,3}))-([А-Я03]|[ABEKMHOPCTYX0]){2}$/.test(
									value
								);
							}, "Заполните, например: IV-ВО или 1У-ВО")
						])
					),
					vb.if(
						() =>
							this.DocumentTypeID() ===
							"RussianDiplomaticPassport",
						vb.all([
							vb.required(true, "Заполните"),
							vb.custom(value => {
								return /\d{2}/.test(value);
							}, "Заполните, например: 22")
						])
					),
					vb.if(
						() => this.DocumentTypeID() === "ForeignPassport",
						vb.all([
							vb.custom(value => {
								return /^[А-ЯЁа-яёA-Za-z0-9().\\\-–№# ]{0,10}$/.test(
									value
								);
							}, "Используются недопустимые символы")
						])
					),
					vb.if(
						() => this.DocumentTypeID() === "RussianPassport",
						vb.all([
							vb.required(true, "Заполните"),
							vb.custom(value => {
								return /\d{4}/.test(value);
							}, "Заполните, например: 2222")
						])
					),
					vb.if(
						() => this.DocumentTypeID() === "RussianTravelPassport",
						vb.all([
							vb.required(true, "Заполните"),
							vb.custom(value => {
								return /\d{2}/.test(value);
							}, "Заполните, например: 22")
						])
					),
					vb.if(
						() => this.DocumentTypeID() === "RussianSeamanPassport",
						vb.all([
							vb.required(true, "Заполните"),
							vb.custom(value => {
								return /^[А-Я03]{2}$|^[ABEKMHOPCTYX0]{2}$/.test(
									value
								);
							}, "Заполните, например: АА или 0A")
						])
					),
					vb.if(
						() =>
							this.DocumentTypeID() === "RussianMilitaryPassport",
						vb.all([
							vb.required(true, "Заполните"),
							vb.custom(value => {
								return /[А-Я03]{2}$|^[ABEKMHOPCTYX0]{2}/.test(
									value
								);
							}, "Заполните, например: АА или 0A")
						])
					)
				])
			})
			.extend({ notify: "always" });

		this.documentNumber = this._params.documentNumber
			.extend({
				validation: vb.all([
					vb.if(
						() => this.DocumentTypeID() === "RussianRefugeeID",
						vb.all([
							vb.required(true, "Заполните"),
							vb.custom(value => {
								return /^[0-9]{1,12}$/.test(value);
							}, "Могут быть только цифры")
						])
					),
					vb.if(
						() =>
							this.DocumentTypeID() === "RussianResidencePermit",
						vb.all([
							vb.required(true, "Заполните"),
							vb.custom(value => {
								return value && value.length >= 5;
							}, "Должно быть не менее 5-ти символов"),
							vb.custom(value => {
								return /^[0-9]/.test(value);
							}, "Могут быть только цифры")
						])
					),
					vb.if(
						() =>
							this.DocumentTypeID() === "RussianBirthCertificate",
						vb.all([
							vb.required(true, "Заполните"),
							vb.custom(value => {
								return /\d{6}/.test(value);
							}, "Заполните, например: 222222")
						])
					),
					vb.if(
						() => this.DocumentTypeID() === "RussianTemporaryID",
						vb.all([
							vb.required(true, "Заполните"),
							vb.custom(value => {
								return /^[0-9]{1,12}$/.test(value);
							}, "Могут быть только цифры")
						])
					),
					vb.if(
						() =>
							this.DocumentTypeID() ===
							"RussianDiplomaticPassport",
						vb.all([
							vb.required(true, "Заполните"),
							vb.custom(value => {
								return /\d{7}/.test(value);
							}, "Заполните, например: 2222222")
						])
					),
					vb.if(
						() => this.DocumentTypeID() === "ForeignPassport",
						vb.all([
							vb.required(true, "Заполните"),
							vb.custom(value => {
								return /^[A-Za-z0-9]{1,10}$/.test(value);
							}, "Используются недопустимые символы")
						])
					),
					vb.if(
						() => this.DocumentTypeID() === "RussianPassport",
						vb.all([
							vb.required(true, "Заполните"),
							vb.custom(value => {
								return /\d{6}/.test(value);
							}, "Заполните, например: 222222")
						])
					),
					vb.if(
						() => this.DocumentTypeID() === "RussianTravelPassport",
						vb.all([
							vb.required(true, "Заполните"),
							vb.custom(value => {
								return /\d{7}/.test(value);
							}, "Заполните, например: 2222222")
						])
					),
					vb.if(
						() => this.DocumentTypeID() === "RussianSeamanPassport",
						vb.all([
							vb.required(true, "Заполните"),
							vb.custom(
								value => {
									return /^[0-9]{6,7}$/.test(value);
								},
								() => {
									if (
										this.documentNumber() &&
										this.documentNumber().length < 6
									) {
										return "Должно быть не менее 6-ти символов";
									}

									return "Могут быть только цифры";
								}
							)
						])
					),
					vb.if(
						() =>
							this.DocumentTypeID() === "RussianMilitaryPassport",
						vb.all([
							vb.required(true, "Заполните"),
							vb.custom(
								value => {
									return /^[0-9]{6,7}$/.test(value);
								},
								() => {
									if (
										this.documentNumber() &&
										this.documentNumber().length < 6
									) {
										return "Должно быть не менее 6-ти символов";
									}

									return "Могут быть только цифры";
								}
							)
						])
					)
				])
			})
			.extend({ notify: "always" });

		this.DocumentCountryName = this._params.documentCountryName;

		this.DocumentCountryID = this._params.documentCountryID;

		this._documentCountryDataset = this._params.documentCountryDataset;

		this._documentTypeIsForeign = ko.pureComputed(() =>
			this.DocumentTypeID.isDocumentForeignPassport()
		);

		this._withIdentityCountryInput = ko.observable(
			this._params.withIdentityCountryInput
		);

		this._documentsFullOptions = this._params.documentTypes;

		this._documentsShortOptions = this._params.documentTypes.filter(
			type => type.IsPopular
		);

		this._isShortOptionsEmpty = _.isEmpty(this._documentsShortOptions);

		this._activeDocument = ko.oneOf([
			// Currently active part of document
			null, // none (e.g. when field is blured)
			"series", // editing series
			"number" // edititng number
		]);
	}

	_updateActiveDocument(documentInput) {
		const value = documentInput.value;
		const caret = documentInput.selectionStart;
		const beforeCaret = value
			.slice(0, caret)
			.replace(/\s+/g, " ")
			.replace(/^\s*/, "");
		const wordsBeforeCaret = beforeCaret.split(" ").length - 1;

		this._activeDocument(["series", "number"][wordsBeforeCaret] || null);
	}

	getSeriesTooltipText() {
		if (this.DocumentTypeID() === "ForeignPassport") {
			return "Допустимые символы: А-ЯЁа-яёA-Za-z0-9().\\\\-–№#";
		}

		return "";
	}

	getNumberTooltipText() {
		if (this.DocumentTypeID() === "ForeignPassport") {
			return "Допустимые символы: любые буквы латиницы или цифры";
		}

		return "";
	}

	getMaxSeriesLength() {
		if (this.DocumentTypeID() === "RussianRefugeeID") {
			return 2;
		}

		if (this.DocumentTypeID() === "RussianResidencePermit") {
			return 6;
		}

		if (this.DocumentTypeID() === "RussianBirthCertificate") {
			return 9;
		}

		if (this.DocumentTypeID() === "RussianTemporaryID") {
			return 10;
		}

		if (this.DocumentTypeID() === "RussianMilitaryPassport") {
			return 2;
		}

		if (this.DocumentTypeID() === "RussianDiplomaticPassport") {
			return 2;
		}

		if (this.DocumentTypeID() === "ForeignPassport") {
			return 10;
		}

		if (this.DocumentTypeID() === "RussianPassport") {
			return 4;
		}

		if (this.DocumentTypeID() === "RussianTravelPassport") {
			return 2;
		}

		if (this.DocumentTypeID() === "RussianSeamanPassport") {
			return 2;
		}

		return 10;
	}

	getMaxNumberLength() {
		if (this.DocumentTypeID() === "RussianRefugeeID") {
			return 12;
		}

		if (this.DocumentTypeID() === "RussianResidencePermit") {
			return 7;
		}

		if (this.DocumentTypeID() === "RussianBirthCertificate") {
			return 6;
		}

		if (this.DocumentTypeID() === "RussianTemporaryID") {
			return 12;
		}

		if (this.DocumentTypeID() === "RussianMilitaryPassport") {
			return 7;
		}

		if (this.DocumentTypeID() === "RussianDiplomaticPassport") {
			return 7;
		}

		if (this.DocumentTypeID() === "ForeignPassport") {
			return 10;
		}

		if (this.DocumentTypeID() === "RussianPassport") {
			return 6;
		}

		if (this.DocumentTypeID() === "RussianTravelPassport") {
			return 7;
		}

		if (this.DocumentTypeID() === "RussianSeamanPassport") {
			return 7;
		}

		return 12;
	}

	_onDocumentClick(data, e) {
		this._updateActiveDocument(e.target);
		return true;
	}

	_onDocumentKeyup(data, e) {
		this._updateActiveDocument(e.target);
		return true;
	}

	_onDocumentBlur() {
		this._activeDocument(null);
		return true;
	}
}

module.exports = Model;
